import { useRef, useEffect } from 'react';

const useOutsideFocus = (callback) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const ref = useRef(null);
    useEffect(() => {
        const handleFocusChange = (event) => {
            if (!ref.current.contains(event.relatedTarget)) {
                callback();
            }
        };
        if (ref.current) {
            ref.current.addEventListener('focusout', handleFocusChange, true);
        }
        return () => {
            var _a;
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('focusout', handleFocusChange, true);
        };
    }, [ref]);
    return ref;
};

export { useOutsideFocus as default };
//# sourceMappingURL=useOutsideFocus.js.map
